export default __webpack_public_path__ + "static/media/submitted_icon.249fb650.svg";